import responsiveBg from './responsive-bg';
import megaMenu from './mega-menu';
import mobileMenu from './mobile-menu';
import wistia from './wistia-interface';
import modal from './modal';
import returnToCollection from './retrun-to-collection';
import singleResource from './single-resource';
import paidAd from './paid-ad';
import employeeCookie from './employee-cookie';
import openPositions from './open-positions';
import promoModal from './promo-modal';
import authorFeed from './author-feed';
import gartnerReview from './gartner-review';

export default {
    init() {
        responsiveBg.init();
        megaMenu.init();
        mobileMenu.init();
        wistia.init();
        modal.init();
        returnToCollection.init();
        singleResource.init();
        paidAd.init();
        employeeCookie.init();
        openPositions.init();
        promoModal.init();
        authorFeed.init();
        gartnerReview.init();
    },
};
